export default __webpack_public_path__ + "static/media/Handguards of Clawing Might.6e0c3a0a.jpg";